// Web Mercator's y-axis, and its inverse — pure math, in its own module so the
// tests can import it without dragging maplibre-gl (whose import assumes a
// browser) into a node bundle.
//
// Why the field renderer needs this at all: a MapLibre image source is stretched
// LINEARLY across its quad in projected (Mercator) space, while a naive raster of
// a lat/lon grid spaces its rows linearly in LATITUDE. Mercator is convex in
// latitude, so the two disagree everywhere except the corners: an
// equirectangular image on a Mercator quad paints every interior row poleward of
// its true position — north in the northern hemisphere — by an error that grows
// with the square of the quad's span. On the old few-degree windows that was a
// mile or two and nobody saw it; on the wide views the global grid invites, it
// is half a degree to whole degrees, and the field visibly slid north off its
// coastlines. The renderer therefore spaces its rows linearly in MERCATOR y and
// converts each row back to latitude before sampling the grid.

/** The latitude at which Web Mercator ends: atan(sinh(π)). Beyond it y diverges,
 *  so a quad corner claiming lat 90 cannot be placed — it must be clamped HERE,
 *  and the image rendered for the clamped extent, or the whole texture squeezes
 *  poleward. */
export const MERC_MAX_LAT = 85.05112877980659;

/** Latitude (degrees) → Mercator y (unitless, natural-log form). */
export function mercY(latDeg: number): number {
  return Math.log(Math.tan(Math.PI / 4 + (latDeg * Math.PI) / 360));
}

/** Mercator y → latitude (degrees). Exact inverse of mercY. */
export function latOfMercY(y: number): number {
  return ((2 * Math.atan(Math.exp(y)) - Math.PI / 2) * 180) / Math.PI;
}
